import { useEffect, useState } from 'react'

type TickCallback = () => void

// Module-level singleton — bitta setInterval barcha subscriber'lar uchun
let intervalId: ReturnType<typeof setInterval> | null = null
const subscribers = new Set<TickCallback>()

function startTicker() {
  if (intervalId !== null) return
  intervalId = setInterval(() => {
    subscribers.forEach((cb) => cb())
  }, 1000)
}

function stopTicker() {
  if (subscribers.size > 0) return
  if (intervalId !== null) {
    clearInterval(intervalId)
    intervalId = null
  }
}

function subscribe(cb: TickCallback): () => void {
  subscribers.add(cb)
  startTicker()
  return () => {
    subscribers.delete(cb)
    stopTicker()
  }
}

/**
 * Returns the current Date.now() value, updated once per second via a
 * single shared setInterval. All subscribers share one timer regardless
 * of how many components call this hook.
 */
export function useTick(): number {
  const [now, setNow] = useState(() => Date.now())

  useEffect(() => {
    const unsubscribe = subscribe(() => setNow(Date.now()))
    return unsubscribe
  }, [])

  return now
}
